import { css, keyframes } from 'styled-components';
// import MainBackdrop from '../../assets/images/background_main.png';
// import MainLogo from '../../assets/images/logo_brand.png';
import { getDerivedHSL } from 'src/utils';

export const BREAKPOINTS = {
  PHONE: 544,
  TABLET: 768,
  DESKTOP: 1012,
  WIDE_DESKTOP: 1280,
  XL_DESKTOP: 1366,
};

export const transitionDurations = {
  VERY_FAST_TRANSIT: '80ms',
  FAST_TRANSIT: '160ms',
  MEDIUM_TRANSIT: '240ms',
  SLOW_TRANSIT: '320ms',
  VERY_SLOW_TRANSIT: '560ms',
};

const media = Object.keys(BREAKPOINTS).reduce(
  (acc, label) => ({
    ...acc,
    [label]: (...args) => css`
      @media screen and (max-width: ${BREAKPOINTS[label]}px) {
        ${css(...args)}
      }
    `,
  }),
  {},
);

const mappedKeyFrames = {
  smoothBounce: keyframes`
    0% { transform: translateY(0); }
    20% { transform: translateY(0); }
    40% { transform: translateY(0); }
    50% { transform: translateY(5px); }
    80% { transform: translateY(0); }
    100% { transform: translateY(0); }
  `,
};

const namedColors = {
  BLACK: '#000000',
  MATISSE: '#126D8E',
  MINE_SHAFT: '#333333',
  SCORPION: '#606060',
  SHARK: '#202224',
  JELLY_BEAN: '#297B98',
  TUNDORA: '#404040',
  RIVER_BED: '#4C6067',
  RHINO: '#323462',
  HIPPIE_BLUE: '#5093AB',
  PORT_GORE_LIGHT: '#5F6185',
  PORT_GORE: '#1C1F52',
  DOVE_GRAY: '#707070',
  WATERLOO: '#8181A5',
  DUSTY_GRAY: '#979797',
  SILVER: '#B9B9B9',
  CARNATION: '#F25A6F',
  BRICK_RED: '#BE3144',
  BRICK_RED_LIGHT: getDerivedHSL('#BE3144', 0, 26, 18),
  BRICK_RED_DARK: '#C02E42',
  ALTO: '#D6D3D3',
  GALLERY: '#EAEAEA',
  ATHENS_GRAY: '#EFEFF2',
  CATSKILL_WHITE: '#F1F4F9',
  WHISPER: '#F5F6FA',
  ALABASTER: '#FAFAFA',
  WHITE_LILAC: '#FAFBFD',
  WHITE: '#FFFFFF',
  CONCRETE: '#F2F2F2',
  PRIMARY_BLUE: '#005EFF',
  DARK_BLUE: '#008dff',
  PATTENS_BLUE: '#E9F3FC',
  TROUT: '#4F5460',
  JAVA: '#1ACEBC',
  JAVA_LIGHT: '#F3F9F9',
  DENIM: '#106EC5',
  LINK_WATER: '#ECF3FA',
  LINK_WATER_LIGHT: '#dbe8f7',
  LIGHT_WHITE: '#f0f0f0',
  GRAY_WHITE: '#e0e0e0',
  DISABLED: 'hsl(0, 0%, 95%)',
  FOCUS: '#2584FF',
  MINE_DARK: '#212121',
  BOULDER: '#757575',

  BLACK_RGB_16: 'rgba(0, 0, 0, 0.16)',
  BLACK_RGB_8: 'rgba(0, 0, 0, 0.08)',
  BLACK_RGB_4: 'rgba(0, 0, 0, 0.04)',
  BALCK_RGB_12: 'rgba(0, 0, 0, 0.24)',

  SUCCESS: '#3C9D4F',
  WARNING: '#D1782C',
  ERROR: '#D64256',
  DANGER: '#D64256',
};

const borderRadius = {
  BORDER_RADIUS_XS: '8px',
  BORDER_RADIUS_S: '12px',
  BORDER_RADIUS_M: '14px',
  BORDER_RADIUS_L: '18px',
  BORDER_RADIUS_XL: '24px',
};

export default {
  default: {
    PRIMARY_COLOR: namedColors.BRICK_RED,
    PRIMARY_COLOR_LIGHT: namedColors.BRICK_RED_LIGHT,
    FOREGROUND_COLOR: namedColors.WHITE,
    PRIMARY_COLOR_BORDER: namedColors.SILVER,
    PRIMARY_COLOR_TEXT: namedColors.SHARK,
    BORDER_COLOR_INPUT: namedColors.ALTO,
    BACKGROUND_COLOR_INPUT: namedColors.CATSKILL_WHITE,
    FONT_BORDER: namedColors.DOVE_GRAY,
    LINK_COLOR: namedColors.MATISSE,
    LINK_WATER: namedColors.LINK_WATER,
    LINK_WATER_LIGHT: namedColors.LINK_WATER_LIGHT,

    LIGHT_FONT: 300,
    REGULAR_FONT: 400,
    SEMI_BOLD_FONT: 600,
    BOLD_FONT: 700,
    EXTRA_BOLD_FONT_HEAD: 800,
    EXTRA_BOLD_FONT_BASE: 900,

    X_SMALL: '10px',
    SMALL: '12px',
    MEDIUM: '14px',
    LARGE: '16px',
    X_LARGE: '18px',
    XX_LARGE: '20px',
    XXX_LARGE: '22px',
    SUB_HEADING: '24px',
    AVG_HEADING: '28px',
    HEADING: '32px',
    PAGE_HEADING: '40px',

    ...media,
    ...namedColors,
    ...mappedKeyFrames,
    ...transitionDurations,
    ...borderRadius,

    // MainLogo,
    // MainBackdrop,
  },
};
